import type {SuppliedFilterProvider} from '@github-ui/filter'
import {ISSUE_TYPE_FILTER_KEY, type IssueTypeFilterProvider} from '@github-ui/issue-type-filter-provider'

export function isTypeFilterProvider(
  filterProvider: SuppliedFilterProvider,
): filterProvider is IssueTypeFilterProvider {
  return 'displayName' in filterProvider && filterProvider.displayName === ISSUE_TYPE_FILTER_KEY.displayName
}
